import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(() => ({
  flatIconButton: { padding: 0 },
  kitName: {
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    wordBreak: 'break-word',
  },
  detailsIcon: {
    marginLeft: -5,
  },
  removeIcon: {
    display: 'inline-flex',
    marginTop: 5,
    '& svg': {
      height: 22,
      width: 22,
    },
  },
}));
